/* Salud y Vita - product deck (v14).
   Dots / thumbnails / counter / arrows for the swipe gallery, the product
   video (attached only when its slide is on screen), and a tap-to-zoom viewer
   so the Supplement Facts panel can actually be read on a phone.

   The deck itself is plain CSS scroll-snap, so it swipes with no JS at all;
   everything here is navigation and polish on top. Dependency-free. */
(function () {
  'use strict';

  if (window.__bvDeckInit) return;
  window.__bvDeckInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var lowData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');

  /* ---------- zoom viewer ---------- */

  var zoom = null;
  var zoomLast = null;

  function buildZoom() {
    if (zoom) return zoom;
    zoom = document.createElement('div');
    zoom.className = 'bv-zoom';
    zoom.setAttribute('role', 'dialog');
    zoom.setAttribute('aria-modal', 'true');
    zoom.setAttribute('aria-label', 'Zoomed image');
    zoom.innerHTML =
      '<div class="bv-zoom__pane"><img class="bv-zoom__img" alt=""></div>' +
      '<button type="button" class="bv-zoom__x" aria-label="Close">' +
      '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<span class="bv-zoom__hint">Tap the image to zoom in or out</span>';
    document.body.appendChild(zoom);

    var pane = zoom.querySelector('.bv-zoom__pane');
    var img = zoom.querySelector('.bv-zoom__img');

    zoom.querySelector('.bv-zoom__x').addEventListener('click', closeZoom);
    pane.addEventListener('click', function (e) { if (e.target === pane) closeZoom(); });

    /* Tap toggles 1x <-> zoomed, keeping the tapped point under the finger. */
    img.addEventListener('click', function (e) {
      var r = img.getBoundingClientRect();
      var fx = (e.clientX - r.left) / r.width;
      var fy = (e.clientY - r.top) / r.height;
      var on = !zoom.classList.contains('is-zoomed');
      zoom.classList.toggle('is-zoomed', on);
      if (on) {
        var r2 = img.getBoundingClientRect();
        pane.scrollLeft = fx * r2.width - pane.clientWidth / 2;
        pane.scrollTop = fy * r2.height - pane.clientHeight / 2;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && zoom.classList.contains('is-open')) closeZoom();
    });
    return zoom;
  }

  function openZoom(src, alt) {
    buildZoom();
    zoomLast = document.activeElement;
    var img = zoom.querySelector('.bv-zoom__img');
    img.src = src;
    img.alt = alt || '';
    zoom.classList.remove('is-zoomed');
    zoom.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    zoom.querySelector('.bv-zoom__x').focus();
  }

  function closeZoom() {
    if (!zoom) return;
    zoom.classList.remove('is-open', 'is-zoomed');
    document.documentElement.style.overflow = '';
    if (zoomLast && zoomLast.focus) zoomLast.focus();
  }

  /* ---------- deck ---------- */

  function initDeck(deck) {
    if (deck.dataset.bvBound === '1') return;
    deck.dataset.bvBound = '1';

    var track = deck.querySelector('[data-bv-deck-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-bv-slide]'));
    var n = slides.length;
    if (!n) return;

    var dotsHost = deck.querySelector('[data-bv-deck-dots]');
    var thumbsHost = deck.querySelector('[data-bv-deck-thumbs]');
    var count = deck.querySelector('[data-bv-deck-count]');
    var prev = deck.querySelector('[data-bv-deck-prev]');
    var next = deck.querySelector('[data-bv-deck-next]');
    var dots = [];
    var thumbs = [];
    var cur = -1;

    slides.forEach(function (s, i) {
      s.setAttribute('role', 'group');
      s.setAttribute('aria-roledescription', 'slide');
      s.setAttribute('aria-label', (i + 1) + ' of ' + n);
    });

    if (n > 1) {
      slides.forEach(function (s, i) {
        if (dotsHost) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'bv-dk__dot';
          d.setAttribute('aria-label', 'Show slide ' + (i + 1) + ' of ' + n);
          d.addEventListener('click', function () { go(i); });
          dotsHost.appendChild(d);
          dots.push(d);
        }
        if (thumbsHost) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'bv-dk__thumb';
          var label = s.getAttribute('data-thumb-label');
          var src = s.getAttribute('data-thumb');
          if (label) {
            b.classList.add('bv-dk__thumb--label');
            var sp = document.createElement('span');
            sp.textContent = label;
            b.appendChild(sp);
            b.setAttribute('aria-label', 'Show ' + label);
            /* Thumb tile takes the card's own ground: spine colour, bone or white. */
            if (s.classList.contains('bv-dkc--dose') || s.classList.contains('bv-dkc--how')) {
              b.style.background = s.classList.contains('bv-dkc--how') ? '#fff' : '#efece4';
              sp.style.color = '#17181a';
            }
          } else if (src) {
            var im = document.createElement('img');
            im.src = src;
            im.alt = '';
            im.loading = 'lazy';
            im.decoding = 'async';
            b.appendChild(im);
            b.setAttribute('aria-label', 'Show image ' + (i + 1));
            if (s.hasAttribute('data-thumb-video')) {
              b.classList.add('bv-dk__thumb--video');
              b.setAttribute('aria-label', 'Show video');
            }
          }
          b.addEventListener('click', function () { go(i); });
          li.appendChild(b);
          thumbsHost.appendChild(li);
          thumbs.push(b);
        }
      });
    } else {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    function padLeft() {
      return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
    }

    function go(i, instant) {
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({
        left: slides[i].offsetLeft - padLeft(),
        behavior: instant || reduced ? 'auto' : 'smooth'
      });
    }

    function nearest() {
      var x = track.scrollLeft + padLeft();
      var best = 0;
      var bestD = Infinity;
      for (var i = 0; i < n; i++) {
        var d = Math.abs(slides[i].offsetLeft - x);
        if (d < bestD) { bestD = d; best = i; }
      }
      /* The last slide can't snap to start on a phone (the track runs out),
         so treat "scrolled to the end" as the last slide. */
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = n - 1;
      return best;
    }

    function paint(i) {
      if (i === cur) return;
      cur = i;
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (count && n > 1) count.textContent = (i + 1) + ' / ' + n;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
      syncVideo(i);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; paint(nearest()); });
    }, { passive: true });

    /* scrollend where supported; the rAF handler above covers the rest. */
    track.addEventListener('scrollend', function () { paint(nearest()); });

    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      else if (e.key === 'Home') { e.preventDefault(); go(0); }
      else if (e.key === 'End') { e.preventDefault(); go(n - 1); }
    });

    /* ---- video: only the slide on screen plays, and only if the page is
       visible, the visitor allows motion and isn't saving data. ---- */
    var videos = slides.map(function (s) { return s.querySelector('[data-bv-deck-video]'); });
    var deckSeen = false;

    function syncVideo(i) {
      videos.forEach(function (v, j) {
        if (!v) return;
        var want = j === i && deckSeen && !reduced && !lowData && !document.hidden;
        if (want) {
          if (!v.getAttribute('src') && v.dataset.src) v.setAttribute('src', v.dataset.src);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          deckSeen = en.isIntersecting;
          var keep = cur;
          cur = -1; /* force a repaint so syncVideo re-evaluates */
          paint(keep < 0 ? 0 : keep);
        });
      }, { threshold: 0.4 }).observe(track);
    } else {
      deckSeen = true;
    }

    document.addEventListener('visibilitychange', function () {
      var keep = cur;
      cur = -1;
      paint(keep < 0 ? 0 : keep);
    });

    /* ---- zoom: tap a photo slide. A drag that scrolled the deck is not a tap. ---- */
    var downX = 0;
    track.addEventListener('pointerdown', function (e) { downX = e.clientX; }, { passive: true });
    track.addEventListener('click', function (e) {
      if (Math.abs(e.clientX - downX) > 8) return;
      var s = e.target.closest('[data-zoom]');
      if (!s || !track.contains(s)) return;
      var im = s.querySelector('img');
      openZoom(s.getAttribute('data-zoom'), im ? im.alt : '');
    });

    paint(0);
  }

  function init(scope) {
    var decks = (scope || document).querySelectorAll('[data-bv-deck]');
    for (var i = 0; i < decks.length; i++) initDeck(decks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
